export class Status {
    _id: string = '';
    name: string = '';
    order: number;
    createdAt: string = '';
}
